import React, {useEffect, Fragment, useMemo} from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import {cloneFlowGroupsAndEdges, setBufferWizardItems} from "../wizardFlowActions";
import {wizardEdgeInterface, wizardNodeInterface} from "../WizardItem/wizardItemInterface";
import MaterialsIcons from "../../Icons/MaterialsIcons";

// let pastButtonTimeoutId = null;

const WizardGroupsTopButtonsCopyPaste = (props) => {

  const {wizardActiveItem, buttonsDisabled, selectedWizardNodes, selectedWizardEdges, cloneFlowGroupsAndEdges,
    setBufferWizardItems, bufferWizardNodes, bufferWizardEdges, bufferWizardItem} = props;
  // const {wizardGroups} = wizardActiveItem;

  // const [hasBuffer, setHasBuffer] = useState(false);
  // const [pasteClicked, setPasteClicked] = useState(false);
  const pasteClicked = false;

  const duplicateSelectedClick = () => {
    if (!selectedWizardNodes.length && !selectedWizardEdges.length) {
      return false
    }
    cloneFlowGroupsAndEdges(selectedWizardNodes, selectedWizardEdges, wizardActiveItem, wizardActiveItem);
  }

  const copyButtonClick = () => {
    // setHasBuffer(true);
    setBufferWizardItems([...selectedWizardNodes], [...selectedWizardEdges], wizardActiveItem);
  }

  const pasteButtonClick = () => {
    console.log("restore BufferWizardNodes", bufferWizardNodes);
    // setHasBuffer(false);
    // setPasteClicked(true);
    // pastButtonTimeoutId = setTimeout(() => {
    //   setPasteClicked(false);
    // }, 300)
    cloneFlowGroupsAndEdges(bufferWizardNodes, bufferWizardEdges, bufferWizardItem, wizardActiveItem);
  }

  const copyPasteListener = (event) => {

    // Ctrl+C or Cmd+C pressed?
    if ((event.ctrlKey || event.metaKey) && event.keyCode === 67) {
      copyButtonClick();
    }

    // Ctrl+V or Cmd+V pressed?
    if (((event.ctrlKey || event.metaKey) && event.keyCode === 86) && (bufferWizardNodes.length || bufferWizardEdges.length)) {
      pasteButtonClick();
    }
  }

  useEffect(() => {
    document.removeEventListener("keydown", copyPasteListener); // we need to delete old listener with other selected values on update
    document.addEventListener("keydown", copyPasteListener);
    return () => {
      document.removeEventListener("keydown", copyPasteListener);
    }
  }, [wizardActiveItem, selectedWizardNodes, selectedWizardEdges, bufferWizardNodes, bufferWizardEdges]);

  const pasteDisabled = useMemo(() => !bufferWizardNodes.length && !bufferWizardEdges.length, [bufferWizardNodes, bufferWizardEdges]);
  const hasBuffer = !pasteDisabled;

  return (
    <Fragment>
      {/*<button className={"ui-button--add ui-button5 ui-button5--gray ui-button5--with-icon"*/}
      {/*  + (buttonsDisabled ? " ui-button5--disabled" : "")}*/}
      {/*        onClick={duplicateSelectedClick}>*/}
      {/*  <span className="relative ui-icon-copy ui-icon-copy--gray" style={{transform: "translateX(-1.5px)"}}>*/}
      {/*    <span className="ui-icon-copy__line"/>*/}
      {/*  </span>*/}
      {/*  <FormattedMessage id="wizard.groups.copy"/>*/}
      {/*</button>*/}
      <button className={"flex! flex--center gap-05 pl-05 pr-1 ui-button5 ui-button5--gray ui-button5--with-icon"
        + (buttonsDisabled ? " ui-button5--disabled" : "")}
              onClick={copyButtonClick}>
        <span className="w-15 h-15" style={{
          color: hasBuffer ? "#9fc621" : "#ababab", transform: "scale(0.9)", flexShrink: 0,
        }}>{MaterialsIcons.CopyIcon}</span>
        <span className="flex--1"><FormattedMessage id="wizard.groups.copy"/></span>
      </button>
      <button className={"flex! flex--center gap-05 pl-05 pr-1 ui-button5 ui-button5--gray ui-button5--with-icon"
        + (pasteDisabled ? " ui-button5--disabled" : "")}
              onClick={pasteButtonClick}>
        <div className="w-15 h-15"
             style={{
               color: pasteClicked ? "#9fc621" : "#ababab", transform: "scale(0.9)", flexShrink: 0,
             }}>{MaterialsIcons.PasteIcon}</div>
        <span className="flex--1"><FormattedMessage id="wizard.groups.paste"/></span>
      </button>
    </Fragment>
  )
};

WizardGroupsTopButtonsCopyPaste.propTypes = {
  wizardActiveItem: PropTypes.object.isRequired,
  buttonsDisabled: PropTypes.bool.isRequired,
  selectedWizardNodes: PropTypes.arrayOf(PropTypes.shape(wizardNodeInterface)).isRequired,
  selectedWizardEdges: PropTypes.arrayOf(PropTypes.shape(wizardEdgeInterface)).isRequired,
}

const mapStateToProps = (store) => {
  const {bufferWizardNodes, bufferWizardEdges, bufferWizardItem} = store.wizardState;
  return {
    bufferWizardNodes,
    bufferWizardEdges,
    bufferWizardItem,
  }
};

const mapDispatchToProps = {
  cloneFlowGroupsAndEdges,
  setBufferWizardItems,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardGroupsTopButtonsCopyPaste)
)
